import { Component } from '@angular/core';
import { isSameModel } from '@app/functions';
import { BaseForm } from '@forms/base.form';
import { BenefitDetail } from '@models/benefits/benefit-detail.model';
import { BenefitType } from '@models/benefits/benefit-type.model';
import { Benefit } from '@models/benefits/benefit.model';

@Component({
    selector: 'app-form-benefit-detail',
    templateUrl: './benefit-detail.template.html',
})
export class BenefitDetailForm extends BaseForm {
    benefitDetail: BenefitDetail = new BenefitDetail({
        benefitTypeId: null,
    });
    benefit: Benefit;

    benefitTypes: BenefitType[] = [];

    isSameModel = isSameModel;

    constructor() {
        super();

        BenefitType.orderBy('name', 'ASC')
            .get()
            .then(([benefitTypes]) => {
                this.benefitTypes = benefitTypes;
            });
    }

    setBenefit(benefit: Benefit): void {
        this.benefit = benefit;
        this.benefitDetail = new BenefitDetail();
    }

    setBenefitDetail(benefitDetail: BenefitDetail): void {
        this.benefitDetail = benefitDetail;
    }
}
